import { useMutation } from '@tanstack/react-query';
import { createVision } from 'shared/services/backend-api';
import { NewVision } from 'shared/types/vision';

export const useCreateVisionMutation = () =>
  useMutation({
    mutationFn: async (vision: NewVision) => createVision(vision),
  });
